import { render, staticRenderFns } from "./ShiftSummaryShiftTypeIcon.vue?vue&type=template&id=36702f62&"
import script from "./ShiftSummaryShiftTypeIcon.vue?vue&type=script&lang=js&"
export * from "./ShiftSummaryShiftTypeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports